import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["sidebar", "toggle"]

    connect() {
        // Initialize sidebar as visible
        this.sidebarTarget.classList.remove("d-none")
        this.updateToggleIcon()
    }

    toggle() {
        if (this.sidebarTarget.classList.contains("d-none")) {
            this.show()
        } else {
            this.hide()
        }
    }

    show() {
        this.sidebarTarget.classList.remove("d-none")
        this.updateToggleIcon()
    }

    hide() {
        this.sidebarTarget.classList.add("d-none")
        this.updateToggleIcon()
    }

    updateToggleIcon() {
        const icon = this.toggleTarget.querySelector("i")
        if (this.sidebarTarget.classList.contains("d-none")) {
            icon.className = "bi bi-layout-sidebar-reverse"
        } else {
            icon.className = "bi bi-layout-sidebar"
        }
    }
}
